import { zahlartenDe } from './zahlarten-de';
import { zahlartenEn } from './zahlarten-en';
import { zahlartenTh } from './zahlarten-th';

/**
 * Zahlarten i18n translations (V-0758/V-0774, Korrekturrunde 1, 28.09.2026).
 *
 * Eigener Namensraum statt Eintraege in den grossen `web/src/i18n/locales/*.json` — die tragen
 * gerade grosse fremde, uncommittete Aenderungen anderer Sitzungen. Muster: `web/src/webpos/i18n`
 * (siehe dort fuer die Registrierung in `web/src/i18n/index.ts`).
 */
export const zahlartenTranslations = {
  de: zahlartenDe,
  en: zahlartenEn,
  th: zahlartenTh,
};
